import { createContext } from 'react';
export const DraggingModuleContext = createContext({
    draggingModuleId: null,
    setDraggingModuleId: () => { }
});
